export default __webpack_public_path__ + "img/loginbg.406e6eec.jpg";